// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__dVxZN","formatTag":"Tag_formatTag__IhVyF","crossButtonTag":"Tag_crossButtonTag__lggyP","moreTagFilter":"Tag_moreTagFilter__voenj"};